export default "__VITE_ASSET__UdYOj1t3__"